// extracted by mini-css-extract-plugin
module.exports = {"root":"AppSum_root__111kK","wrapper":"AppSum_wrapper__3dO8u"};